<div class='row'>
  @if (investor?.nip; as nip) {
    <div class="col-md-4">
      <app-label label="NIP:">
        {{ nip }}
      </app-label>
    </div>
  }
  <div class='col-md-4'>
    <app-label label='Numer telefonu:'>
      {{ investor?.phoneNumber || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Numer telefonu2:'>
      {{ investor?.phoneNumber2 || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='E-mail:'>
      {{ investor?.email || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Kod pocztowy:'>
      {{ investor?.postalCode || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Poczta:'>
      {{ investor?.postOffice || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Miejscowość:'>
      {{ investor?.city || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Ulica:'>
      {{ investor?.street || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Nr domu:'>
      {{ investor?.houseNumber || '-' }}
    </app-label>
  </div>
  <div class='col-md-4'>
    <app-label label='Nr mieszkania:'>
      {{ investor?.apartmentNumber || '-' }}
    </app-label>
  </div>
</div>
